module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default plan-and-pricing-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("Plan and Pricing")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.showResumeAlert) ? _c('div', {
    staticClass: "alert alert-warning resume-alert"
  }, [_c('p', [_vm._v("You have cancelled your subscription to the\n\t\t\t\t"), (_vm.activePlan) ? _c('strong', [_vm._v(_vm._s(_vm.activePlan.name) + " ($" + _vm._s(_vm.activePlan.price) + " " + _vm._s(_vm.activePlan.interval) + ")")]) : _vm._e(), _vm._v(" plan.\n\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("The benefits of your subscription will continue until your current billing period ends on\n\t\t\t\t"), (_vm.hasSubscription) ? _c('strong', [_vm._v(_vm._s(_vm.subscription.ends_at))]) : _vm._e(), _vm._v(". You may resume your subscription at no\n\t\t\t\textra cost until the end of the billing period.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.routes.resume_subscription
    }
  }, [_vm._v("Resume Subscription")])])]) : _vm._e(), _vm._v(" "), (_vm.showPricingTable) ? _c('table', {
    staticClass: "table pricing-table"
  }, [_c('tbody', _vm._l((_vm.plans), function(plan) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "table-spacer"
    }, [_c('strong', [_vm._v(_vm._s(plan.name))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "table-spacer"
    }, [_c('ul', {
      staticClass: "features"
    }, _vm._l((plan.features), function(feature) {
      return _c('li', [_vm._v(_vm._s(feature))])
    }))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "table-spacer"
    }, [_vm._v("\n\t\t\t\t\t\t$" + _vm._s(plan.price) + " " + _vm._s(plan.interval) + "\n\t\t\t\t\t\t"), (_vm.coupon) ? _c('span', [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(_vm.showChangeButton(plan.id)) ? _c('a', {
      staticClass: "btn",
      class: [_vm.isCurrentPlan(plan.id) ? 'btn-default' : 'btn-primary'],
      attrs: {
        "href": _vm.routes.change_plan + '?plan_id=' + plan.id,
        "disabled": _vm.isCurrentPlan(plan.id)
      },
      on: {
        "click": _vm.confirmChange
      }
    }, [_vm._v(_vm._s(_vm.changeButtonText(plan.id)))]) : _vm._e(), _vm._v(" "), (_vm.showUpgradeButton(plan.id)) ? _c('div', [(_vm.isCurrentPlan(plan.id)) ? _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "disabled": ""
      }
    }, [_vm._v("Current Plan")]) : _c('stripe-upgrade', {
      attrs: {
        "form-data": _vm.stripeForm,
        "action": _vm.routes.form_post_subscribe,
        "text": "Upgrade",
        "plan": plan,
        "coupon": _vm.coupon
      }
    })], 1) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showCancelButton()) ? _c('a', {
    staticClass: "btn btn-danger cancel-btn",
    attrs: {
      "href": _vm.routes.cancel_subscription
    },
    on: {
      "click": _vm.confirmCancel
    }
  }, [_vm._v("Cancel Subscription")]) : _vm._e(), _vm._v(" "), (_vm.coupon) ? _c('div', {
    staticClass: "alert alert-info coupon-alert"
  }, [_vm._v("\n\t\t\t* price before coupon is applied\n\t\t")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ae874e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/PlanAndPricing.vue
// module id = 15
// module chunks = 0